export const TwentyTwo = '4';